import React from 'react';
import { CustomSticky } from '../ui/sticky/CustomSticky';
import { FormButton } from '../ui/buttons/FormButton';
import FooterButtonContainer from './components/FooterButtonContainer';
import { Half } from './components/Half';

const t = {
  move_ticket: 'Mark as moved to TMS',
  save: 'Save changes',
  cancel: 'Cancel ticket',
  new: 'Create new ticket',
};
const NewTicketFormFooter = ({ ticketFormFooterData }) => {
  const {
    backendErrors,
    setShowErrors,
    isWaitingForResponse,
    submitFormikForm,
    //  onCancel
  } = ticketFormFooterData;
  const hasBackendErrors = Object.keys(backendErrors).length > 0;
  return (
    <>
      {/* <FormButton variant="ghost" onClick={onCancel}>
        Back
      </FormButton> */}
      <Half></Half>
      <Half>
        <FormButton
          isDisabled={isWaitingForResponse}
          onClick={() => {
            setShowErrors(true);
            submitFormikForm();
          }}
        >
          {t.new}
          {hasBackendErrors && <> ⚠️ </>}
        </FormButton>
      </Half>
    </>
  );
};

const TicketDetailCancelFormFooter = ({ ticketFormFooterData }) => {
  const { onCancelTicket } = ticketFormFooterData;
  return (
    <>
      <Half> </Half>
      <Half>
        <FormButton variant="ghost" onClick={onCancelTicket}>
          {t.cancel}
        </FormButton>
      </Half>
    </>
  );
};

const TicketDetailEditFormFooter = ({ ticketFormFooterData }) => {
  const {
    backendErrors,
    setShowErrors,
    isWaitingForResponse,
    submitFormikForm,
    // onCancel,
    onCancelTicket,
    isCancellable,
    dirty,
  } = ticketFormFooterData;
  const hasBackendErrors = Object.keys(backendErrors).length > 0;

  return (
    <>
      {isCancellable && (
        <FormButton variant="ghost" onClick={onCancelTicket}>
          {t.cancel}
        </FormButton>
      )}
      <FormButton
        isDisabled={isWaitingForResponse || !dirty}
        onClick={() => {
          setShowErrors(true);
          submitFormikForm();
        }}
      >
        {t.save} {hasBackendErrors && <> ⚠️ </>}
      </FormButton>
    </>
  );
};

const AcceptedQuoteFormFooter = ({ ticketFormFooterData }) => {
  const { onMarkTicketAsDone, isCancellable, onCancelTicket } = ticketFormFooterData;
  return (
    <>
      {isCancellable && (
        <FormButton variant="ghost" onClick={onCancelTicket}>
          {t.cancel}
        </FormButton>
      )}
      {!!onMarkTicketAsDone && (
        <FormButton onClick={onMarkTicketAsDone}>{t.move_ticket}</FormButton>
      )}
    </>
  );
};

export const TicketFormFooter = ({ ticketFormFooterData }) => {
  const { isEdit, isReadOnly, isDone, isQuoteAccepted } = ticketFormFooterData;
  // TODO: Move to a common form footer with if conditions to show buttons
  if (isDone && isReadOnly)
    return (
      <CustomSticky>
        <FooterButtonContainer>
          <TicketDetailCancelFormFooter ticketFormFooterData={ticketFormFooterData} />
        </FooterButtonContainer>
      </CustomSticky>
    );
  if (!isQuoteAccepted && isReadOnly) return <></>;
  return (
    <CustomSticky>
      <FooterButtonContainer>
        {isReadOnly ? (
          <AcceptedQuoteFormFooter ticketFormFooterData={ticketFormFooterData} />
        ) : isEdit ? (
          <TicketDetailEditFormFooter ticketFormFooterData={ticketFormFooterData} />
        ) : (
          <NewTicketFormFooter ticketFormFooterData={ticketFormFooterData} />
        )}
      </FooterButtonContainer>
    </CustomSticky>
  );
};
